/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-const-assign */
import React, { useState, useEffect } from 'react'

import './Header.scss'

import { Link } from 'react-router-dom'

import otherIcon from '../../assets/svg/otherIcon.svg'
import infoIcon from '../../assets/svg/infoIcon.svg'
import instagramIcon from '../../assets/svg/instagramIcon.svg'
import twitterIcon from '../../assets/svg/twitterIcon.svg'
import telegramIcon from '../../assets/svg/telegramIcon.svg'

import { get } from '../../services/https'

export default function index({ name }) {
  const [toggleState, setToggleState] = useState(true)
  const id = localStorage.getItem('shopId')
  const [shop, setShop] = useState()

  const toggleOther = () => {
    setToggleState(!toggleState)
  }

  useEffect(() => {
    get(`/api/front/shops/${id}`)
      .then(response => {
        setShop(response.data.data[0])
      })
  }, [id])

  return (
    <div id='header'>
      <div className="headerBody">
        <div className="otherPart" style={toggleState ? { display: 'none' } : {}}>
          <ul>
            <li>
              <Link to='/about'>
                <img src={infoIcon} alt="infoIcon" />درباره ما
              </Link>
            </li>
            <li>
              <Link to={shop ? shop.instagram : ''}>
                <img src={instagramIcon} alt="instagramIcon" />اینستاگرام
              </Link>
            </li>
            <li>
              <Link to={shop ? shop.tellegram : ''}>
                <img src={telegramIcon} alt="telegramIcon" />تلگرام
              </Link>
            </li>
            <li>
              <Link to={shop ? shop.twitter : ''} target='_blank'>
                <img src={twitterIcon} alt="twitterIcon" />توئیتر
              </Link>
            </li>
          </ul>
        </div>
        <Link to='/'>
          <span className='foodName'>
            {shop ? shop.name : 'رستوران کانولی'}
          </span>
        </Link>

        <span className='other' onClick={toggleOther}>
          <img src={otherIcon} alt='otherIcon' />
        </span>
      </div>
    </div>
  )
}
